// 答题卡片模式
export enum ExamItemCardModeEnum {
  /**
   * 预览模式 只能看不能做题
   */
  Review = 1,
  /**
   * 考试模式 可以做题
   */
  Exam = 2,
}

// 题目类型
export enum QuestionTypeEnum {
  /**
   * 单选题 - A question with a single correct answer from a predefined set of choices.
   */
  SingleChoice = 1,

  /**
   * 多选题 - A question with multiple correct answers from a predefined set of choices, where the user must select all applicable options.
   */
  MultipleChoice = 2,

  /**
   * 判断题 - A question that requires the user to determine if a statement is true or false.
   */
  Judge = 3,

  /**
   * 填空题 - A question with one or more gaps that the user must fill in with appropriate responses.
   */
  Fill = 4,

  /**
   * 问答题 - A question that calls for a short, written response from the user, typically involving explanation, reasoning, or synthesis.
   */
  ShortAnswer = 5,

  /**
   * 编程题 - A question that requires the user to write code to solve a specific problem or demonstrate programming concepts.
   */
  Program = 6,

  /**
   * 不定项选择题 - A question with multiple possible correct answers from a predefined set, but the number of correct answers is not specified (i.e., the user may choose any combination of options).
   */
  IndefiniteChoice = 7,

  /**
   * 完型填空题 - A question that presents a passage with missing words or phrases, which the user must fill in correctly to complete the text.
   */
  GestaltFill = 8,

  /**
   * 完型单选 - A question that presents a passage with missing words or phrases, which the user must select a single correct answer from a predefined set of choices.
   */
  GestaltSingleChoice = 9,

  /**
   * 材料题 - A question accompanied by supporting material (e.g., text, image, video), where the user must determine if a statement related to the material is true or false.
   */
  Material = 10,

  /**
   * 材料题（答题方式单选） - A question accompanied by supporting material (e.g., text, image, video), where the user selects a single correct answer from a predefined set of choices.
   */
  MaterialSingleChoice = 11,

  /**
   * 材料题（答题方式多选） - A question accompanied by supporting material, where the user selects multiple correct answers from a predefined set of choices.
   */
  MaterialMultipleChoice = 12,

  /**
   * 材料题（答题方式判断选） - A question accompanied by supporting material, where the user determines if a statement related to the material is true or false.
   */
  MaterialJudge = 13,

  /**
   * 材料题（答题方式问答） - A question accompanied by supporting material, which requires a short, written response from the user based on the material provided.
   */
  MaterialShortAnswer = 14,

  /**
   * 论文题 - A question that requires the user to write a complete research paper, typically involving a specific topic or subject matter.
   */
  Paper = 15,
}

export const QuestionTypeName: {
  [key in keyof Partial<typeof QuestionTypeEnum>]: string;
} = {
  [QuestionTypeEnum.SingleChoice]: '单选题',
  [QuestionTypeEnum.MultipleChoice]: '多选题',
  [QuestionTypeEnum.Judge]: '判断题',
  [QuestionTypeEnum.Fill]: '填空题',
};
